/**
 * Copyright Mántum All Rights Reserved.
 */
import Internal from '../internal/input';
import { ACTION_VALUE, useGroup } from '../../group';
import { formatter } from '@mantum/kanela';
import { forwardRef, useEffect, useRef, useState } from 'react';

import type { Validation } from '@mantum/kanela';

const currency = formatter.currency;

export type PropTypes = {
    disabled?: boolean;
    error?: boolean;
    name?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    onChange?: (name?: string, value?: unknown) => void;
    optional?: boolean;
    placeholder?: string;
    testid?: string;
    validation?: Validation;
    value?: number;
};

export default forwardRef<HTMLInputElement, PropTypes>(
    function Component(props, ref) {
        // prettier-ignore
        const { 
        name, 
        onChange,
        value = 0
    } = props;

        const changeRef = useRef(onChange);

        useEffect(() => {
            changeRef.current = onChange;
        }, [onChange]);

        const [currentValue, setCurrentValue] = useState<string>(
            currency.format(value, {
                digits: 0
            })
        );

        useEffect(() => {
            if (changeRef.current) {
                changeRef.current(name, value);
            }
        }, [name, value]);

        const handleChange = (name?: string, value?: unknown) => {
            const normalize = currency.unformat(value as string);
            const current = currency.format(normalize, {
                digits: 0
            });

            setCurrentValue(current);
            if (onChange) {
                onChange(name, normalize);
            }
        };

        const groups = useGroup();

        useEffect(() => {
            if (!name || !groups) {
                return;
            }

            if (!(name in groups)) {
                return;
            }

            const content = groups[name];
            if (content.action === ACTION_VALUE) {
                const value = `${content.value}`;
                setCurrentValue(value);

                if (changeRef.current) {
                    changeRef.current(name, value);
                }
            }
        }, [name, groups]);

        return (
            <Internal
                autocomplete='off'
                disabled={props.disabled}
                error={props.error}
                name={props.name}
                onBlur={props.onBlur}
                onChange={handleChange}
                placeholder={props.placeholder}
                ref={ref}
                testid={props.testid}
                type='text'
                value={currentValue}
            />
        );
    }
);
